import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Motion } from '@stepstone-genesis/components';
export const FadeTransition = ({ transitionKey, children, }) => {
    return (_jsx(Motion, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.5 }, 
        // this `willChange` is needed to prevent flickering on Safari
        sx: { willChange: 'opacity' }, children: children }, transitionKey));
};
//# sourceMappingURL=FadeTransition.js.map